module.exports = __webpack_public_path__ + "assets/img/estudio-cuneo-logo.svg";